var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M11.9998 2C14.3002 2 16.6006 2.89705 18.3998 4.7C21.8662 8.27891 21.8662 14.0961 18.3998 17.6C18.3558 17.6841 15.5736 20.6156 11.9998 23C8.42535 20.6156 5.64374 17.6841 5.59978 17.6C2.13341 14.0961 2.13341 8.27891 5.59978 4.7C7.39894 2.89705 9.69938 2 11.9998 2ZM7.5323 16.7321C7.89418 17.0953 8.33365 17.5151 8.81984 17.9563C9.82886 18.8719 10.9021 19.7578 11.9997 20.5601C13.0972 19.7578 14.1704 18.8718 15.1795 17.9562C15.6658 17.515 16.1053 17.0952 16.4673 16.732C16.5746 16.6244 16.6692 16.5275 16.7452 16.448L16.978 16.1934C19.6725 13.4697 19.6759 8.90387 16.9735 6.10213C15.5975 4.72861 13.8305 4 11.9998 4C10.1691 4 8.40203 4.72861 7.02607 6.10213C4.32367 8.90387 4.3271 13.4697 7.02159 16.1934L7.23308 16.4072C7.33038 16.5276 7.42503 16.6245 7.5323 16.7321ZM11.9998 9.6C13.1044 9.6 13.9998 10.4954 13.9998 11.6C13.9998 12.7046 13.1044 13.6 11.9998 13.6C10.8952 13.6 9.99978 12.7046 9.99978 11.6C9.99978 10.4954 10.8952 9.6 11.9998 9.6Z'
      })
    ),
    props
  );
}

module.exports = Icon;
